import styled from 'styled-components'

export const HAZE_SIZE = '2rem'

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 2rem;
  margin-bottom: 2rem;
  background-color: ${({ theme }) => theme.colour.secondary._100};
`

/**
 * Adds a divider with a fade above it
 */
export const FadedDivider = styled.div<{ paddingBottom?: string }>`
  position: relative;
  padding-bottom: ${({ paddingBottom }) => paddingBottom ?? '1rem'};

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colour.secondary._100};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: ${HAZE_SIZE};
    background: linear-gradient(
      to top,
      #fff,
      rgba(255, 255, 255, 0.5) 80%,
      rgba(255, 255, 255, 0)
    );
  }
`
